// BSC network helpers and ERC20 USDT balance fetcher
import { ethers } from "ethers";

export const BSC_MAINNET = {
  chainId: 56,
  chainIdHex: "0x38",
  name: "BNB Smart Chain",
  rpc: "https://bsc-dataseed.binance.org",
  explorer: "https://bscscan.com",
  nativeSymbol: "BNB",
};

export const BSC_TESTNET = {
  chainId: 97,
  chainIdHex: "0x61",
  name: "BNB Smart Chain Testnet",
  rpc: "https://data-seed-prebsc-1-s1.binance.org:8545",
  explorer: "https://testnet.bscscan.com",
  nativeSymbol: "tBNB",
};

export const USDT_BSC = "0x55d398326f99059fF775485246999027B3197955"; // 18 decimals on BSC

export const ERC20_ABI = [
  "function balanceOf(address) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function symbol() view returns (string)",
];

export function shortAddr(addr, head = 6, tail = 4) {
  if (!addr) return "";
  return `${addr.slice(0, head)}...${addr.slice(-tail)}`;
}

export function formatNumber(n, opts = {}) {
  const v = Number(n || 0);
  return v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 6, ...opts });
}

export async function fetchBnbAndUsdtBalance(address, chainId) {
  // Use a public RPC matching network (so it works even if wallet on wrong chain UI)
  const net = chainId === 97 ? BSC_TESTNET : BSC_MAINNET;
  const provider = new ethers.JsonRpcProvider(net.rpc);
  try {
    const bnbBal = await provider.getBalance(address);
    let usdt = 0n;
    try {
      const usdtAddr = chainId === 97 ? "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd" : USDT_BSC;
      const usdtContract = new ethers.Contract(usdtAddr, ERC20_ABI, provider);
      usdt = await usdtContract.balanceOf(address);
    } catch (e) {
      usdt = 0n;
    }
    return {
      bnb: Number(ethers.formatEther(bnbBal)),
      usdt: Number(ethers.formatUnits(usdt, 18)),
      network: net.name,
      explorer: net.explorer,
    };
  } catch (e) {
    return { bnb: 0, usdt: 0, network: net.name, explorer: net.explorer, error: e.message };
  }
}
